import {callAPI, invokeAPI} from './commonBusiness';

import {setInitialLabware} from '../actions/availableLabwareStateAction';

import {ApiRouteMap, SignalREvent, SignalRHub} from '../../constants/dataEnum';

export const createLabwareDefinitions = (labwareDefinitions) => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlLabwareDefinitionRepository;

  try {
    const response = await callAPI('POST', baseUrl, ApiRouteMap.CREATE_LABWARE_DEFINITIONS, labwareDefinitions);

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const readLabwareDefinitions =
  (page = 0, pageSize = 10, sort = {}, filter = []) =>
  async (dispatch, getState) => {
    const state = getState();
    const {configState} = state;
    const baseUrl = configState.hubHost.urlLabwareDefinitionRepository;

    try {
      const response = await callAPI('POST', baseUrl, ApiRouteMap.READ_LABWARE_DEFINITIONS, {
        page,
        pageSize,
        sort,
        filter,
      });

      return response;
    } catch (err) {
      return err?.response?.data;
    }
  };

export const updateLabwareDefinition = (labwareDefinition) => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlLabwareDefinitionRepository;

  try {
    const response = await callAPI('PUT', baseUrl, ApiRouteMap.UPDATE_LABWARE_DEFINITION, labwareDefinition);

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const deleteLabwareDefinitions = (ids) => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;

  try {
    const response = await callAPI('DELETE', baseUrl, ApiRouteMap.DELETE_LABWARE_DEFINITIONS, ids);
    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const duplicateLabwareDefinitions = (ids) => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlLabwareDefinitionRepository;

  try {
    const response = await callAPI('POST', baseUrl, ApiRouteMap.DUPLICATE_LABWARE_DEFINITIONS, ids);

    return response;
  } catch (err) {
    return err?.response?.data;
  }
};

export const refreshLabwareDefinitions = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.LABWARE_DEFINITION, SignalREvent.GET_LABWARE_DEFINITIONS));

  dispatch(setInitialLabware(response));

  return response;
};
